<div class="profile mx-auto">
    <div class="row flex-direction-wrapper max-width-wrapper mx-auto justify-content-between profile-wrapper">
        <div class="col-3 col-sm-3 col-md-2 px-0">
            <div class="row">
                <div class="menu text-nowrap">
                    <h1 class="heading" routerLink="/account/profile/my-profile">My Profile</h1>
                    <img class="user-img" src="../images/user-avatar.png" class="user-img mb-5" >
                    <ul class="list-group pl-0">
                        <li class="list-group-item"><a routerLink="/account/profile/personal-details">Personal Details</a></li>
                        <li class="list-group-item"><a routerLink="/account/profile/login-security">Login & Security</a></li>
                        <li class="list-group-item"><a routerLink="/account/profile/invoices">Invoices</a></li>
                        <li class="list-group-item"><a routerLink="/account/profile/address">Address</a></li>
                        <li class="list-group-item"><a routerLink="/account/profile/newsletter">Newsletter</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-8 col-md-9 mx-0 ms-0 px-0 card-group--tablet-bp">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
